import { Box, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { ForwardedRef, ReactNode } from 'react';
import { forwardRef } from 'react';
import { SubMenu } from '@/shared/ui';
import { useHeaderHovered } from './useHeaderHovered';

const LabelWrapper = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontWeight: 500,
  marginRight: theme.spacing(1),
}));

interface Props {
  field: string;
  title: string;
  description?: string;
  quickActions: (hovered: boolean) => ReactNode;
  menuOptions: Parameters<typeof SubMenu>[0]['options'];
  onMenuOptionClick: Parameters<typeof SubMenu>[0]['onOptionClick'];
}

export const HeaderCell = forwardRef(
  (
    {
      field,
      title,
      description,
      quickActions,
      menuOptions,
      onMenuOptionClick,
    }: Props,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    const hovered = useHeaderHovered(field);

    return (
      // need to use fragment to allow grid expand columns width by values
      <>
        <Tooltip
          arrow
          title={
            <>
              <p>{title}</p>
              {description && <p>{description}</p>}
            </>
          }
        >
          <LabelWrapper>{title}</LabelWrapper>
        </Tooltip>
        <Box ref={ref} sx={{ display: 'flex', alignItems: 'center' }}>
          {quickActions(hovered)}
          <SubMenu options={menuOptions} onOptionClick={onMenuOptionClick} />
        </Box>
      </>
    );
  },
);
